import axios from "axios";
import Notify from "./module/notify";

const notify = new Notify();
const wp = wp_metis;

let self = null;
class Metis {
  constructor() {
    this._token = wp.token;
    this._url = wp.url;
    this._metisUrl = wp.metisUrl;
    self = this;
    // console.log(this._token);
  }

  async metisRequest(query, showError = true, passError = false, ignoreErrors = false) {
    let headers = {
      "content-type": "text/plain",
    };

    if (wp_metis["token"]) {
      headers = {
        "content-type": "application/json",
        accept: "application/json",
        Authorization: "Bearer " + this._token,
      };
    }

    headers['Metisurl'] = this._metisUrl;

    const config = {
      headers: headers,
    };

    const response = await axios.post(this._url, query, config);

    if (response.data.errors) {
      if (showError) {
        notify.emit(response.data.errors);
      }
      if (response.data.errors && response.data.errors.length > 0) {
        jQuery.ajax({
          type: "post",
          url: ajaxurl,
          data: {
            action: "write_error_to_file",
            data: { errors: response.data.errors },
          },
          // success: function (response) {
          //   console.log("Wrote error(s) to file");
          // },
          // error: function (error) {
          //   console.log("Error writing error to file", error);
          // },
        });
      }
      if (passError) {
        return response.data.errors;
      } else if (ignoreErrors) {
        return response.data.data;
      } else {
        return null;
      }
    } else {
      return response.data.data;
    }
  }

  async payOneRequest(url, body) {
    const headers = {
      "content-type": "application/x-www-form-urlencoded",
      accept: "application/json",
    };

    const config = {
      headers: headers,
      body: body,
    };

    const response = await axios.post(url, config);

    localStorage.setItem("payOneRequest", JSON.stringify(response));

    return response;
  }

  async isLoggedIn() {
    if (!this.getCookieValue('metis_logged_in')) {
      return false;
    }

    const request = this.metisRequest({
      query: `
        query {
          isLoggedIn
        }`,
    });

    const response = await request;
    return response.isLoggedIn;
  }

  async getAllAnreden() {
    const request = this.metisRequest({
      query: `
        query {
            getAllAnreden {
            kurzbezeichnung
            langbezeichnung
            sortierungsnr
            }
        }`,
    });

    const response = await request;
    return response.getAllAnreden;
  }

  async getAllNametitel() {
    const request = this.metisRequest({
      query: `
        query {
            getAllNametitel {
            kurzbezeichnung
            langbezeichnung
            sortierungsnr
            }
        }`,
    });

    const response = await request;
    return response.getAllNametitel;
  }

  async getTermine() {
    const request = this.metisRequest({
      query: `
            query {
                getUserTermine {
                  kursTermine {
                    kursnr
                    kursbez
                    termine {
                      terminnr
                      veranstnr
                      profil {
                        id
                        mandant {
                          mandantennummer
                          bezeichnung
                        }
                        identKey
                        email
                        anrede {
                          kurzbezeichnung
                          langbezeichnung
                          sortierungsnr
                        }
                        nametitel {
                          kurzbezeichnung
                          langbezeichnung
                          sortierungsnr
                        }
                        vorname
                        nachname
                        usernameOrg
                        aktiviert
                        rollen {
                          name
                        }
                        updateTime
                        createTime
                      }
                      raum {
                        id
                        raumnr
                        ablauftermin
                        anlauftermin
                        bezeichnung
                        kosten
                        veranstaltungsort {
                          ort
                          plz
                          strasse
                          postfach
                          telefon
                          telefax
                          email
                          webseite
                          oeffnungszeiten {
                            datum
                            von
                            bis
                          }
                        }
                        mehrfachraumext
                        quadratmeter
                        gesperrtAb
                        gesperrtBis
                        onlinebuchbar
                        maxPersonenanzahl
                      }
                      unterrichtsfach {
                        fachnr
                        fachbez
                        info
                        massnahmenabschnitt
                      }
                      ausstattvarindex
                      belegtbisz
                      belegtvonz
                      bewirtet
                      bezeichnung
                      datum
                      displays
                      listenausdruck
                      persanzahl
                      persanzahltats
                      persanzbewirtet
                      veranstvonz
                      stunden
                      veranstbisz
                      zausstatt
                      prgname
                      bemerkung
                      createTime
                      updateTime
                    }
                  }
                }
              }
         `,
    });

    const response = await request;
    return response.getUserTermine;
  }

  displayTermine(termine) {
    const KeineTermineBlock = document.querySelector("#no_courses");

    if (!termine.length) {
      KeineTermineBlock.classList.remove("d-none");
      return true;
    }
  }

  toggleButton(button) {
    button.disabled = true;

    setTimeout(function () {
      button.disabled = false;
    }, 3000);
  }

  getCookieValue(name) {
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || false;
  }
}

export default Metis;
